export interface PatientData {
  id: number;
  userId: number;
}

export const initialPrsonData: PatientData = {
  id: 0,
  userId: 0,
};

export interface TrackerData {
  id: number;
  recordId: number;
  workflowId: number;
  consultingRoomId: number;
  insuranceId: number;
  note: string | null;
  assignedToRole: number | null;
  assignedToUser: number | null;
  createAndSubmit: boolean;
}

export const initialTrackerData: TrackerData = {
  id: 0,
  recordId: 0,
  workflowId: 0,
  consultingRoomId: 0,
  insuranceId: 0,
  note: null,
  assignedToRole: null,
  assignedToUser: null,
  createAndSubmit: false,
};

export interface TrackerRecordData {
  recordId: number;
  trackerNo: string;
  taskLevel: number;
}
